// extracted by mini-css-extract-plugin
export default {"title":"ktHIhq4F3ZTgrz95THr9","description":"yjhO0KCVENx43EGHd_Sm","heplerText":"nAGqhCECRZnbu3A5EEJw"};